<script setup>
import {ref} from 'vue'
import {
    Dialog,
    DialogPanel, TransitionRoot,
} from '@headlessui/vue'
import NavComponent from "./NavComponent.vue";

defineProps({
    guide: Object,
    parentGuide: Object,
    category: Object,
    categories: Array
})

const isOpen = ref(false)

function setIsOpen(value) {
    isOpen.value = value
}
</script>

<template>
    <div class="py-4 lg:hidden">
        <div class="max-w-full w-[1536px] mx-auto px-6 relative flex items-center">
            <button type="button"
                    @click="setIsOpen(true)"
                    class="text-slate-500 hover:text-orange outline-none shadow-none"><span
                class="sr-only">Навигация</span>
                <svg width="24" height="24">
                    <path d="M5 6h14M5 12h14M5 18h14" fill="none" stroke="currentColor" stroke-width="2"
                          stroke-linecap="round"></path>
                </svg>
            </button>
            <ol class="ml-4 flex text-sm leading-6 whitespace-nowrap min-w-0">
                <li class="flex items-center">{{ category.title }}
                    <svg width="3" height="6" aria-hidden="true" class="mx-3 overflow-visible text-slate-400">
                        <path d="M0 0L3 3L0 6" fill="none" stroke="currentColor" stroke-width="1.5"
                              stroke-linecap="round"></path>
                    </svg>
                </li>
                <li class="font-semibold text-slate-900 dark:text-slate-100 truncate">{{ guide.title }}</li>
            </ol>
        </div>
    </div>
    <TransitionRoot
        :show="isOpen"
        as="template"
        enter="duration-100 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-100 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
    >
        <Dialog @close="setIsOpen">
            <div class="fixed inset-0 bg-black/30 z-40" aria-hidden="true"/>
            <DialogPanel
                class="fixed top-0 left-0 bg-white dark:bg-bg-dark w-80 max-w-[calc(100%-3rem)] p-6 z-40 h-screen overflow-y-scroll">
                <button type="button"
                        @click="setIsOpen(false)"
                        class="absolute z-10 top-5 right-5 w-8 h-8 flex items-center justify-center outline-none shadow-none"
                        tabindex="0"><span class="sr-only">Close navigation</span>
                    <svg viewBox="0 0 10 10" class="w-2.5 h-2.5 overflow-visible">
                        <path d="M0 0L10 10M10 0L0 10" fill="none" stroke="currentColor" stroke-width="2"
                              stroke-linecap="round"></path>
                    </svg>
                </button>
                <NavComponent :categories="categories" :category="category" :guide="guide" :parent-guide="parentGuide" classes="text-sm relative"/>
            </DialogPanel>
        </Dialog>
    </TransitionRoot>
</template>

<style lang="scss">
</style>
